@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ConfigurationTypeButton {
  @extend %font-family-primary;

  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  align-items: center;
  background: $color-transparent;
  border: 1px solid $theme-color-form-control-border;
  border-radius: 6px;
  display: flex;
  min-width: 20px;
  max-width: 120px;
  flex-direction: row;
  padding: 2px 6px;
  column-gap: 4px;

  &.isFocus {
    background-color: $theme-color-secondary-button-hover;
  }

  .textWrapper {
    color: var(--light-text);
  }

  &:hover {
    background-color: $theme-color-secondary-button-hover;
    border-radius: 6px;
  }
}
